import { useEffect, useState } from 'react';

const API = 'https://alterus.onrender.com';

export default function CloneScore({ email, dark }) {
  const [score, setScore] = useState(null);
  const [chunks, setChunks] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!email) return;
    fetch(`${API}/api/clone-score?user_email=${encodeURIComponent(email)}`)
      .then(r => r.json())
      .then(d => {
        setChunks(d.chunks || 0);
        setScore(d.score || 0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [email]);

  const getLevel = (s) => {
    if (s >= 80) return { label: 'Expert Clone', color: '#22c55e', next: null };
    if (s >= 60) return { label: 'Strong Clone', color: '#6366f1', next: `${80 - s} points to Expert` };
    if (s >= 40) return { label: 'Learning', color: '#f59e0b', next: `${60 - s} points to Strong` };
    if (s >= 20) return { label: 'Early Stage', color: '#f59e0b', next: `${40 - s} points to Learning` };
    return { label: 'Just Started', color: '#5a607a', next: 'Approve 10 drafts to level up' };
  };

  const level = getLevel(score || 0);

  const steps = [
    { action: '✍️ Approve a draft', points: '+2 pts', done: chunks > 5 },
    { action: '✏️ Edit a draft', points: '+1 pt', done: chunks > 10 },
    { action: '🎥 Analyze a Zoom meeting', points: '+3 pts', done: chunks > 15 },
    { action: '👥 Build stakeholder profiles', points: '+2 pts', done: chunks > 20 },
    { action: '🔄 Run self-healer', points: '+1 pt', done: false },
  ];

  if (loading) return (
    <div style={{ color: '#3a3f55', fontSize: 11, fontFamily: 'DM Mono' }}>Loading...</div>
  );

  return (
    <div>
      {/* Score circle */}
      <div style={{ textAlign: 'center', marginBottom: 12 }}>
        <div style={{
          width: 80, height: 80, borderRadius: '50%',
          border: `4px solid ${level.color}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 8px',
          background: level.color + '11'
        }}>
          <span style={{ fontSize: 26, fontWeight: 700, fontFamily: 'Syne, sans-serif', color: level.color }}>
            {score || 0}
          </span>
        </div>
        <div style={{ fontSize: 12, fontWeight: 600, color: level.color }}>{level.label}</div>
        {level.next && (
          <div style={{ fontSize: 10, color: '#3a3f55', fontFamily: 'DM Mono', marginTop: 3 }}>{level.next}</div>
        )}
      </div>

      {/* Progress bar */}
      <div style={{ background: '#1e2235', borderRadius: 4, height: 4, marginBottom: 12, overflow: 'hidden' }}>
        <div style={{ width: `${score || 0}%`, height: '100%', background: level.color, borderRadius: 4, transition: 'width 1s ease' }} />
      </div>

      {/* Corpus stat */}
      <div style={{ fontSize: 10, color: '#3a3f55', fontFamily: 'DM Mono', textAlign: 'center', marginBottom: 12 }}>
        {chunks} corpus chunks · grows with every use
      </div>

      {/* How to improve */}
      <div style={{ background: '#0a0d16', border: '1px solid #1e2235', borderRadius: 8, padding: '10px 12px' }}>
        <div style={{ fontSize: 10, color: '#5a607a', fontFamily: 'DM Mono', marginBottom: 8 }}>HOW TO IMPROVE</div>
        {steps.map((s, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
            <span style={{ fontSize: 11, color: s.done ? '#22c55e' : '#5a607a' }}>
              {s.done ? '✅' : '○'} {s.action}
            </span>
            <span style={{ fontSize: 10, fontFamily: 'DM Mono', color: '#6366f1' }}>{s.points}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
